import React from 'react';
import { string } from 'prop-types';
import Box from '../../atoms/Box';
import Select from '../../atoms/inputField/Select';



export const CURRENCY_EURO = 'EUR';
export const CURRENCY_SWISS_FRANC = 'CHF';

export const CURRENCIES = [CURRENCY_EURO, CURRENCY_SWISS_FRANC];

const InputCurrency = React.forwardRef(({ name, value, ...props }, ref) => {
  return (
    <Box minWidth="100px">
      <Select defaultValue={value} ref={ref} name={name} {...props}>
        {CURRENCIES.map(c => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </Select>
    </Box>
  );
});

InputCurrency.propTypes = {
  value: string,
  name: string
};

export default InputCurrency;
